/**
 * Loading skeletons + empty state + error state for the feed.
 */
import { Card } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";
import { CheckCircleIcon, AlertIcon } from "@/components/ui/icons";

export function FeedSkeleton() {
  return (
    <div className="flex flex-col gap-3" aria-busy="true" aria-label="Загрузка ленты">
      {[0, 1, 2].map((i) => (
        <Card key={i} className="flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <div className="skeleton h-5 w-32 rounded-full" />
            <div className="skeleton h-5 w-20 rounded-full" />
          </div>
          <div className="skeleton h-5 w-3/4 rounded-control" />
          <div className="skeleton h-4 w-1/2 rounded-control" />
          <div className="flex gap-2">
            <div className="skeleton h-9 w-32 rounded-control" />
            <div className="skeleton ml-auto h-9 w-24 rounded-control" />
          </div>
        </Card>
      ))}
    </div>
  );
}

export function FeedEmpty() {
  return (
    <Card className="flex flex-col items-center gap-2 py-12 text-center">
      <CheckCircleIcon size={28} className="text-accent" />
      <h3 className="text-base font-semibold text-ink">Аномалий нет</h3>
      <p className="max-w-sm text-sm text-muted">
        Смена идёт ровно — система не нашла отклонений по выбранным фильтрам.
        Новые карточки появятся здесь автоматически.
      </p>
    </Card>
  );
}

export function FeedError({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) {
  return (
    <Card className="flex flex-col items-center gap-3 py-10 text-center">
      <AlertIcon size={26} className="text-danger" />
      <h3 className="text-base font-semibold text-ink">Не удалось загрузить ленту</h3>
      <p className="max-w-sm text-sm text-muted">{message}</p>
      <Button variant="secondary" size="sm" onClick={onRetry}>
        Повторить
      </Button>
    </Card>
  );
}
